module.exports = __webpack_public_path__ + "static/media/list-icon.5dd1d45d.svg";